/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/no-duplicates */
import * as React from 'react'
import { useLocation, Routes, Route, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { useDispatch, useSelector } from 'react-redux'
import { LoadingOutlined } from '@ant-design/icons'
import { type RootState } from './store/configureReducer'
import { useIdleTimer } from 'react-idle-timer'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { logout } from '@ai/redux/authCredentials'

const Login = React.lazy(async () => await import('./pages/signIn'))
const PageLayout = React.lazy(async () => await import('./pages/static/layout'))
const Home = React.lazy(async () => await import('./pages/root'))
const Upload = React.lazy(async () => await import('./pages/uploads'))
const TrackingUpload = React.lazy(async () => await import('./pages/trackingUploads'))

function CircularIndeterminate (): JSX.Element {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 56px)' }}>
      <LoadingOutlined style={{ fontSize: 40, color: '#cb101a' }} />
    </div>
  )
}

function RequireAuth ({ children }: any): JSX.Element {
  const dispatch = useDispatch()
  const credentials = useSelector((state: RootState) => state.AuthCredentials.credentials)
  const [modal, setModal] = React.useState<boolean>(false)

  const onIdle = () => {
    if (!modal) {
      Modal.warning({
        title: '¡Alerta!',
        content: 'Su sesión se cerrará debido a la inactividad. Por favor, vuelva a iniciar sesión para continuar.',
        okText: 'Ir a iniciar sesión',
        onOk () {
          Modal.destroyAll()
          setModal(false)
          dispatch(logout())
        },
        icon: <ExclamationCircleOutlined style={{ color: '#cb101a' }} />,
        width: '560px',
        okType: 'danger',
        okButtonProps: {
          style: {
            color: 'white',
            backgroundColor: '#cb101a',
            borderColor: '#cb101a'
          },
          danger: true
        }
      })
    }
  }

  const onActive = () => {
    setModal(true)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const idleTimer = useIdleTimer({
    // element: document,
    name: 'activity-timer',
    crossTab: true,
    timeout: 10000 * 6 * 30,
    onIdle,
    onActive
  })

  if (!credentials.accessToken && !credentials.refreshToken) {
    return <Navigate to="/login" replace />
  }

  return children
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function Router () {
  const location = useLocation()

  return (
    <AnimatePresence>
      <Routes
        // location={location}
        key={location.pathname}>
        <Route path='/login' element={<Login />} />
        <Route element={<RequireAuth><PageLayout /></RequireAuth>}>
          <Route
            index
            path='/'
            element={
              <React.Suspense fallback={<CircularIndeterminate />}>
                <Home />
              </React.Suspense>
            } />
          <Route
            index
            path='/uploads'
            element={
              <React.Suspense fallback={<CircularIndeterminate />}>
                <Upload />
              </React.Suspense>
            } />
            <Route
            index
            path='/trackingUploads'
            element={
              <React.Suspense fallback={<CircularIndeterminate />}>
                <TrackingUpload />
              </React.Suspense>
            } />
        </Route>
      </Routes>
    </AnimatePresence>
  )
}
